const getNameLetters = (name: string) => {
  const names = name.split(' ');

  const first = names[0].substring(0, 1);
  const last = names[names.length - 1].substring(0, 1);

  return first + last;
};

export default getNameLetters;
